__turbopack_context__.v({
  "input": "input-module__g1Ti0W__input",
});
